<template>
  <div class="content">
    <div class="logo">
      <img src="../../img/pc/logo.png" />
    </div>
    <div class="banner">
      <img src="../../img/pc/banner.png" />
    </div>
    <div class="center">
      <el-form class="checkNum" label-width="0" :model="validateForm" ref="validateForm">
        <div class="title-container">
          <h3 class="title">请输入工号</h3>
        </div>
        <el-form-item
          prop="workNum"
          :rules="[{required: true,validator: checkWorkNum, trigger: 'change' }]"
        >
          <el-input placeholder="请输入工号" v-model="validateForm.workNum"></el-input>
        </el-form-item>
        <el-form-item
          prop="passWord"
          :rules="[{required: true,validator: checkPassWord, trigger: 'change' }]"
        >
          <el-input placeholder="请输入身份证后6位" v-model="validateForm.passWord"></el-input>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        :disabled="workFlag === 1 && passFlag === 1 ? false : true"
        @click="nextStep('validateForm')"
        v-loading.fullscreen.lock="fullscreenLoading"
      >下一步</el-button>
    </div>
    <tipBox v-bind.sync="showBombTips" :tipsContent="tipsContent"></tipBox>
  </div>
</template>

<script>
import tipBox from "../../components/pc/tipBox";
export default {
  components: {
    tipBox
  },
  data() {
    return {
      workFlag: 0,
      passFlag: 0,
      validateForm: {
        workNum: "",
        passWord: ""
      },
      showBombTips: {
        visible: false
      },
      tipsContent: "",
      fullscreenLoading: false
    };
  },
  methods: {
    checkWorkNum(rule, value, callback) {
      console.log(value, "value");
      if (!value) {
        this.workFlag = 0;
      } else {
        this.workFlag = 1;
        // localStorage.setItem("workNum", value);
        this.$cookieStore.setCookie('workNum', value)
      }
    },
    checkPassWord(rule, value, callback) {
      if (!value) {
        this.passFlag = 0;
      } else {
        this.passFlag = 1;
        this.$cookieStore.setCookie('password', value)
      }
    },
    nextStep() {
      var that = this;
      that.fullscreenLoading = true;
      setTimeout(() => {
        that.fullscreenLoading = false;
      }, 500);
      var params = {
        employeeCode: that.validateForm.workNum,
        identityCardNum: that.validateForm.passWord
      };
      that.$api
        .checkUserInfo(params)
        .then(res => {
          console.log(res.data, "res");
          if (res.data.code === 0) {
            var phone = res.data.data.phone;
            // localStorage.setItem("oldPhone", phone);
            that.$cookieStore.setCookie('oldPhone', phone)
            var editAllow = res.data.data.editAllow;
            // localStorage.setItem("editAllow", editAllow);
            that.$cookieStore.setCookie('editAllow', editAllow)
            that.$router.push('/phoneNum?flag=1');
          } else if (res.data.code === 60002) {
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          } else if (res.data.code === 60003) {
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  },
  created() {
    var flag = this.$route.query.flag;
    console.log(this.$route.query, "this.validateForm");
    if (flag === "1") {
      this.validateForm.workNum = this.$cookieStore.getCookie('workNum');
      this.validateForm.passWord = this.$cookieStore.getCookie('password');
      this.workFlag = 1;
      this.passFlag = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  margin: 0px 40px;
  overflow: hidden;
  position: relative;
  .logo {
    width: 100%;
    img {
      position: absolute;
      top: 24px;
      left: 0px;
    }
  }
  .banner {
    height: 380px;
    img {
      position: absolute;
      left: 0px;
      top: 80px;
      width: 100%;
      height: 380px;
    }
  }
  .center {
    position: relative;
    width: 450px;
    height: 300px;
    margin: 80px auto;
    overflow: hidden;
  }
  .checkNum {
    position: absolute;
    .title-container {
      position: relative;
      .title {
        width: 100px;
        height: 28px;
        margin: 43px 175px 24px 175px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }
    }
  }
  button {
    width: 450px;
    height: 40px;
    padding: 0px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
    border: 0px;
    outline: none;
    margin-top: 230px;
  }
  .blueBtn {
    background: rgba(34, 142, 243, 1);
    border-radius: 4px;
    position: absolute;
    top: 240px;
    left: 0px;
  }
  .grayBtn {
    background: rgba(34, 142, 243, 1);
    border-radius: 4px;
    opacity: 0.45;
    position: absolute;
    top: 240px;
    left: 0px;
  }
  .grayBtn:hover {
    background: rgba(34, 142, 243, 1);
    border-radius: 4px;
    opacity: 0.45;
  }
  .el-form-item {
    margin-bottom: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/workNum.vue